import { Redirect } from 'expo-router'

/** See ./terms.tsx for context — same pattern. */
export default function ProfilePrivacyRedirect() {
  return <Redirect href={'/legal/privacy-policy' as never} />
}
